import Head from "next/head";
import { PageFadeWrapper } from "../../components/PageWrapper";

function PrintTermsAndConditions() {
  return (
    <>
      <Head>
        <title>Space Type - Print Terms &amp; Conditions</title>
        <meta
          property="og:title"
          content="Space Type - Print Terms & Conditions"
        />
      </Head>
      <PageFadeWrapper>
        <div className="nav-spacer--padded mb-24 flex flex-row justify-center">
          <section className="w-[1000px] fade-in pt-12 md:pt-24 px-4 lg:px-12">
            {/* Shipping & Returns */}
            <div className="mb-16">
              <h1 className="felicette-Bold color-gold text-3xl md:text-5xl mb-8">
                Shipping &amp; Returns
              </h1>
              <div className="monochromic-semilight max-w-4xl">
                <p>
                  We provide services within the United States. Upon completion,
                  orders can be picked up in-person at our Brooklyn studio or can
                  be shipped at cost.
                </p>
                <p className="mt-6">
                  All sales are final, and we provide scanned samples to ensure
                  accuracy before delivering the final order. Damaged items from
                  improper box packaging may be exchanged if contacted within 14 days of delivery.
                </p>
                <p className="mt-6">
                  Refunds will not be issued for carrier delays, or orders that cannot be delivered due to incomplete or incorrect shipping addresses. If your order is returned to us due to an address issue (e.g., insufficient address, incorrect address, or refusal), you’ll be required to pay an additional postage fee for us to reship the item.
                </p>
              </div>
            </div>

            {/* Terms & Conditions */}
            <div>
              <h1 className="felicette-Bold color-gold text-3xl md:text-5xl mb-8">
                Terms &amp; Conditions
              </h1>
              <p className="max-w-4xl mb-10">
                By requesting our print services, you accept and agree to the
                following terms and conditions.
              </p>

              <div className="flex flex-col gap-10">
                <div>
                  <h2 className="felicette-Bold text-2xl md:text-3xl mb-4">
                    File setup
                  </h2>
                  <p className="max-w-4xl">
                    As part of the intake process, Space Type reviews the
                    provided print files before production. However, we do not
                    offer editorial or design services as part of this process
                    and cannot guarantee any detailed feedback that is not related to the feasibility and
                    accuracy of printing your designs.
                  </p>
                </div>

                <div>
                  <h2 className="felicette-Bold text-2xl md:text-3xl mb-4">
                    Payment
                  </h2>
                  <p className="max-w-4xl">
                    Production and file preparation will only begin when payment
                    has been made in full according to the agreed invoice. Once
                    we begin production and file preparation, we do not offer
                    refunds.
                  </p>
                </div>

                <div>
                  <h2 className="felicette-Bold text-2xl md:text-3xl mb-4">
                    Production time
                  </h2>
                  <p className="max-w-4xl">
                    While we aim to complete production on print orders within
                    2-3 business days of invoice payment, and zine orders within 2-3
                    weeks, this time depends on the details of each project and
                    is based on a number of factors. Relevant project deadlines
                    must be shared by the client during the intake
                    process, and Space Type will share potential complications
                    that may impact the final production completion date.
                    Shipping and/or pickup is not included in production time.
                  </p>
                </div>

                <div>
                  <h2 className="felicette-Bold text-2xl md:text-3xl mb-4">
                    Print Imperfections
                  </h2>
                  <p className="max-w-4xl">
                    Risograph is a printing process that layers transparent,
                    colored inks to create vibrant images with unique texture
                    qualities. Due to this layering process, slight differences
                    in registration are natural, and roller marks or color smudges may occur. In
                    addition, colors will differ from digital reproductions. Each
                    product is inspected for quality and sent with care, but may
                    be subject to delivery conditions.
                  </p>
                </div>

                <div>
                  <h2 className="felicette-Bold text-2xl md:text-3xl mb-4">
                    Portfolio Rights
                  </h2>
                  <p className="max-w-4xl">
                    Space Type reserves the right to showcase the client&rsquo;s
                    printed work as part of the studio&rsquo;s portfolio,
                    in-person space, website, or social media platforms after the
                    work has publicly launched, unless explicitly requested by
                    the client not to do so.
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </PageFadeWrapper>
    </>
  );
}

PrintTermsAndConditions.displayName = "PrintTermsAndConditions";
export default PrintTermsAndConditions;
